<!--
 * @Author: zs
 * @Date: 2022-04-20 14:14:37
 * @LastEditTime: 2022-04-20 16:34:30
 * @Description:
 * @FilePath: \smart-community\src\components\global\Hdetails.vue
-->
<template>
  <div class="details">
    <div class="textbox">
      <div class="head">
        <div class="border">
          <p>南山路XX号人脸<span>2022-04-20</span></p>
        </div>
        <el-icon
          :style="{'color':'#fff','border-radius':'99%','background':'red','cursor':'pointer'}"
          @click="changeFlag"
        >
          <close />
        </el-icon>
      </div>
      <div class="body">
        <img
          src="@/assets/images/threeSolid/threebg.png"
          alt=""
        >
      </div>
      <div class="foot">
        <div
          class="left"
          @click="onLeft"
        >
          <el-icon :style="{'color':'#4ccbdb'}">
            <arrow-left-bold />
          </el-icon>
        </div>
        <div class="text">
          <ul :style="{'margin-left':margin1+'px'}">
            <li
              v-for="(item,index) in userList"
              :key="index"
              @mouseover="handleMoreOperation(item, index)"
              @mouseleave="handleMoreLeave(item)"
              @click="openwin(item)"
              :style="{'margin-top':item.id===showEareItem ? '-10px' : '0'}"
            >
              <img
                :src='item.url'
                alt=""
              >
            </li>
          </ul>
        </div>
        <div
          class="right"
          @click="onRight"
        >
          <el-icon :style="{'color':'#4ccbdb'}">
            <arrow-right-bold />
          </el-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { Close, ArrowLeftBold, ArrowRightBold } from "@element-plus/icons-vue";
export default defineComponent({
  name: "HDetalis",
  components: { Close, ArrowLeftBold, ArrowRightBold },
  props: {
    userList: {
      type: Array,
      required: true
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      margin1: 0,
      showEareItem: false
    });
    const refData = toRefs(state);
    const changeFlag = () => {
      emit("changeEmit");
    };
    // 向左翻页
    const onLeft = () => {
      console.log("向左");
      if (state.margin1 === 0) {
        state.margin1 = 0;
      } else {
        state.margin1 += 50;
      }
    };
    // 向右翻页
    const onRight = () => {
      var listLenth = props.userList.length * 100;
      if (state.margin1 <= -listLenth) {
        state.margin1 = -listLenth;
      } else {
        state.margin1 -= 50;
      }
    };
    // 鼠标移入显示
    const handleMoreOperation = (item) => {
      state.showEareItem = item.id;
    };
    // 鼠标移出隐藏
    const handleMoreLeave = () => {
      state.showEareItem = false;
    };
    return {
      ...refData,
      changeFlag,
      onLeft,
      onRight,
      handleMoreOperation,
      handleMoreLeave
    };
  }
});
</script>

<style lang="scss" scoped>
.details {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  .textbox {
    width: 1000px;
    height: 800px;
    background: rgba(38, 63, 109, 0.9);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    .head {
      width: 100%;
      height: 30px;
      padding: 10px 15px;
      .border {
        width: 98%;
        height: 40px;
        text-align: center;
        border-bottom: solid 1px #fff;
        padding-bottom: 10px;
      }
      p {
        color: #fff;
      }
    }
    .body {
      width: 80%;
      height: 500px;
      background: url("~@/assets/images/cardbg.png");
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      img {
        width: 100%;
        height: 100%;
        padding: 20px;
      }
    }
    .foot {
      display: flex;
      width: 100%;
      height: 200px;
      position: absolute;
      bottom: 0;
      .left {
        width: 5%;
      }
      .text {
        width: 90%;
        overflow: hidden;
        ul {
          margin-top: 35px;
          display: flex;
          li {
            position: relative;
            margin: 15px 30px;
            width: 100px;
            height: 100px;
            background: url("~@/assets/images/cardbg.png");
            background-size: 100% 100%;
            img {
              width: 90px;
              height: 90px;
              padding: 5px;
            }
            .top {
              position: absolute;
              top: 0px;
              right: 5px;
            }
            .bottom {
              position: absolute;
              bottom: 15px;
              width: 80px;
              background: rgba(0, 0, 0, 0.5);
              text-align: center;
              margin-left: 5px;
            }
          }
        }
      }
      .right {
        width: 5%;
      }
    }
  }
}
</style>